<template xmlns:width="http://www.w3.org/1999/xhtml">
  <div class="page-template">
    <div class="record-statistics-box">
      <div class="statistics-item">
        <div class="txt">历史购买总数</div>
        <div class="txt num">{{ smsNum.buyNum}}条</div>
      </div>
      <div class="statistics-item">
        <div class="txt">历史消费总数</div>
        <div class="txt num">{{ smsNum.consumeNum }}条</div>
      </div>
      <div class="statistics-item">
        <div class="txt">剩余总数</div>
        <div class="txt num">{{ smsNum.leftoverNum }}条</div>
      </div>
    </div>

    <div style="margin-top: 20px">
      <div class="rule-list-box">
        <span>充值规则</span>
        <div class="item-box" v-if="smsRule.length>0">
          <div class="rule-item" :class="{'active':rule.active}" @click="specsClick(rule)"
               v-for="(rule,index) in smsRule" :key="index">
            {{rule.name}}
          </div>
        </div>
        <div class="amount-style">
          <span>应付金额：</span>
          <span class="amount-font">{{ actualAmount }} 元</span>
        </div>
        <div style="margin-top: 20px">主要功能：消费通知</div>
        <div class="btn-box" style="position: absolute;bottom: 10px;width:100%;z-index: 100;">
          <el-button type="primary" @click='renewOption'>立即续费</el-button>
        </div>
      </div>
    </div>

    <div style="margin-top: 20px">
      <el-col :span="24">
        <div class="form-item-title">充值记录</div>
      </el-col>
      <list-operation ref="listOperation" :tableOptions="listColumns"></list-operation>
    </div>

    <el-dialog title="支付码" :visible.sync="showBox" :close-on-click-modal="false">
      <img class="img-box" :src="this.qrCodeUrl"/>
      <div class="font-box">
        <h4>温馨提示：</h4>
        <h4>1、支持支付宝扫码</h4>
        <h4>2、支付码过期后，可关闭页面重新打开</h4>
      </div>
      <div class="btn-box" style="position: absolute;bottom: 10px;width:100%;z-index: 100;">
        <el-button type="primary" @click='confirmPay'>确认支付</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import api from "@/config/api";
  import listOperation from '@/components/template/listOperationPage';
  import fileTemplate from '@/components/controls/fileTemplate';

  export default {
    components: {
      listOperation,
      fileTemplate
    },
    data() {
      return {
        qrCodeUrl: '',
        showBox: false,
        actualAmount: '0.00',
        ruleStr: '',
        smsRule: [],
        smsNum: {
          //历史购买总数
          buyNum: '0.00',
          //历史消费总数
          consumeNum: '0.00',
          //剩余总数
          leftoverNum: '0.00',
        },
        listColumns: {
          summaryColumns: ['actualAmount'],
          columns: [
            {label: '序号', type: 'index', width: 80, prop: 'idx'},
            {
              label: '门店',
              prop: 'storeName',
              width: '90',
              align: "center",
            },
            {
              label: '订单号',
              prop: 'orderNo',
              width: '180',
              align: "center",
            },
            {
              label: "实付金额",
              prop: "actualAmount",
              width: '120',
              align: "center",
            },
            {
              label: "购买规则",
              prop: "ruleStr",
              width: '90',
              align: "center"
            },
            {
              label: '支付状态',
              width: '90',
              prop: 'status',
              align: "center",
              enumData: this.$utils.getCacheStatus("ntNotifySmsRechargeRecord.status"),
            },
            {
              label: '充值日期',
              width: '125',
              prop: 'createDttm',
              align: "center"
            },
            {
              label: '备注',
              width: '90',
              prop: 'remarks',
              align: "center"
            }
          ],
          url: api.notify.rechargeRecord,
        },
      };
    },
    created() {
      this.getSmsNum();
      this.getSmsRule();
      this.getRechargeRecord();
    },
    methods: {
      //点击规则触发事件
      specsClick(rule) {
        rule.active = true;
        this.smsRule.forEach(item => {
          if (item.id !== rule.id) {
            item.active = false;
          }
        });
        let name = rule.name;
        this.ruleStr = name;
        this.actualAmount = name.substring(name.indexOf('￥') + 1, name.indexOf('元'));
      },
      //获取短信充值规则
      getSmsRule() {
        this.$axios.fetchGet(api.notify.smsRule, {}).then(data => {
          if (data.code === 200) {
            this.smsRule = data.data;
          } else {
            this.$message.error("获取短信规则失败");
          }
        })
      },
      //获取充值记录
      getRechargeRecord() {
        let params = {};
        params.pageNumber = 0;
        params.pageSize = 10;
        this.$nextTick(()=>{
          this.$refs['listOperation'].getTableData(params);
        })
      },
      //获取商户（门店）短信数量
      getSmsNum() {
        this.$axios.fetchPost(api.notify.smsNum, {}).then(data => {
          if (data.code === 200) {
            if (data.data) {
              this.smsNum.buyNum = data.data.buyNum;
              this.smsNum.consumeNum = data.data.consumeNum;
              this.smsNum.leftoverNum = data.data.leftoverNum;
            }
          } else {
            this.$message.error("获取短信数量失败");
          }
        })
      },
      renewOption() {
        if (this.actualAmount === '0.00') {
          this.$message.warning("请选择充值金额！");
          return false;
        }
        this.showBox = true;
        let params = {ruleStr: this.ruleStr, actualAmount: this.actualAmount};
        // let params = {ruleStr: this.ruleStr, actualAmount:0.01};
        this.$axios.fetchPost(api.notify.qrCode, params).then(data => {
          if (data.code === 200) {
            this.showBox = true;
            this.qrCodeUrl = data.data.qrCOdeUrl;
          } else {
            this.$message.error("获取支付二维码失败");
          }
        })
      },
      confirmPay(){
        this.getSmsNum();
        this.getRechargeRecord();
        this.showBox = false;
      }
    }
  };
</script>
<style scoped>
  .record-statistics-box {
    width: 100%;
    background-color: rgb(238, 238, 255);
    height: 80px;
    margin-bottom: 10px;
  }

  .record-statistics-box .statistics-item {
    margin-right: 5px;
    margin-top: 5px;
    box-sizing: border-box;
    width: calc(100% / 3 - 20px / 4);
    background-color: #fff;
    height: 70px;
    line-height: 35px;
    float: left;
  }

  .record-statistics-box .statistics-item .txt {
    padding-left: 20px
  }

  .record-statistics-box .statistics-item .num {
    border-top: 1px solid rgb(238, 238, 255);
    color: #5e57e3;
  }

  .item-box {
    right: 100px;
    display: flex;
    flex-direction: row;
  }

  .item-box .rule-item {
    width: 150px;
    height: 30px;
    line-height: 30px;
    margin-right: 10px;
    margin-top: 20px;
    background-color: #fff;
    padding: 0 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: pointer;
    text-align: center;
  }

  .rule-list-box {
    height: 250px;
    padding: 10px 10px 10px 10px;
    background-color: #eee;
    border-radius: 5px;
    position: relative;
  }

  .item-box .rule-item.active {
    border-color: rgb(64, 158, 255);
    color: rgb(64, 158, 255);
  }

  .amount-style {
    padding-top: 20px;
  }

  .amount-style .amount-font {
    color: rgb(255, 138, 39);
    font-size: 20px;
    font-weight: bold;
  }

  .form-item-title {
    padding-bottom: 10px;
    font-weight: bold;
  }

  .img-box {
    width: 300px;
    height: 300px;
    margin-left: 35%;
  }
  .font-box{
    margin-top: 10px;
    color: rgb(255, 40, 37);
    font-size: 15px;
    font-weight: bold;
  }
  .btn-box {
    text-align: center;
    margin-top: 15px;
  }
</style>




// WEBPACK FOOTER //
// src/page/apply/notify/SmsRecharge.vue